import BaseBreadcrumbs from "./Breadcrumbs";

export default BaseBreadcrumbs;
